import React, { memo } from 'react';

import { makeStyles } from '@mui/styles';
import SvgIcon from '@mui/material/SvgIcon';

const useStyles = makeStyles({
  icon: {
    width: '0.65rem',
    height: '0.65rem',
    marginTop: '0.25 rem',
  },
});

const OutlinedSelectIcon = (props) => {
  const styles = useStyles();

  return (
    <SvgIcon {...props} classes={{ root: styles.icon }} viewBox="0 0 14 8">
      <path d="M7 0.625L13.82 7.84375H0.18005L7 0.625Z" />
    </SvgIcon>
  );
};

export default memo(OutlinedSelectIcon);
